import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RecaptchaComponent, ReCaptchaV3Service } from 'ng-recaptcha';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToolsService } from '../../../services/tools.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Event } from '../../../models/event/Event';
import { Mitarbeiter } from '../../../models/mitarbeiter/Mitarbeiter';
import { Thema } from '../../../models/event/Thema';
import { EventItem } from '../../../models/event/EventItem';

export interface DialogData {
    time: {startTime:string, endTime: string},
    office: {officeid:number, name: string},
    day: string,
    partnerid: string,
    mitarbeiter: Mitarbeiter
}

@Component({
    selector: 'app-termin',
    templateUrl: './termin.component.html',
    styleUrls: ['./termin.component.scss'],
    standalone: false
})
export class TerminComponent implements OnInit, OnDestroy {
    @ViewChild('captchaElem') captchaElem: RecaptchaComponent;
    private subscribes = [];
    termindate: DialogData;
    terminform: FormGroup;
    desktopTemplate: boolean = true;
    sitekey: string = '';
    termindata: Event;
    themas: Thema [] = [
        {
            name: 'Reiseberatung & Buchung',
            code: 'rb',
            duration: 60
        },
        {
            name: 'Umbuchung & Stornierung',
            code: 'us',
            duration: 40
        },
        {
            name: 'Abholung Reiseunterlagen',
            code: 'ar',
            duration: 10
        },
        {
            name: 'Titel festlegen',
            code: 'tf',
            duration: 20
        },
    ];

    arts: EventItem [] = [
        {
            name: 'Vor Ort',
            code: 'vo'
        },
        {
            name: 'Telefonisch',
            code: 'tel'
        },
        {
            name: 'Video-Call',
            code: 'vc'
        },
        {
            name: 'Sonstiges',
            code: 'so'
        },
    ];

    constructor (
        private dialogRef: MatDialogRef<TerminComponent>,
        private fb: FormBuilder,
        protected mediaObserver: BreakpointObserver,
        private toolService: ToolsService,
        private recaptchaV3Service: ReCaptchaV3Service,
        @Inject(MAT_DIALOG_DATA) private data: DialogData
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = true;
        }
    }

    ngOnInit (): void {
        this.sitekey = this.toolService.getcaptchasitekey();
        this.termindate = this.data;
        this.terminform = this.fb.group({
            salutation: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            thema: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            art: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            firstname: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            lastname: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            tel: new FormControl(null, [Validators.required, Validators.minLength(2)]),
            email: new FormControl(null, [Validators.required, Validators.email]),
            notiz: new FormControl(null, [Validators.maxLength(5000), Validators.minLength(0)]),
            floatLabel: 'auto',
        });
    }

    
    ngOnDestroy (): void {
        this.subscribes.forEach(element => {
            element.unsubscribe();
        });
    }

    async onNoClick () {
        this.dialogRef.close();
    }

    async registrierenF () {
        if (this.terminform.valid) {
            this.subscribes.push(this.recaptchaV3Service.execute('savetermin')
                .subscribe((token) => this.saveTermin(token)));
        } else {
            this.terminform.markAllAsTouched();
        }
    }

    async saveTermin (token) {
        this.termindata = {} as Event;
        this.termindata.description = this.terminform.value.notiz;
        this.termindata.captcha = token;
        for (let i = 0; i < this.arts.length; i++) {
            if (this.arts[i].code === this.terminform.value.art) {
                this.termindata.art = this.arts[i];
                i = this.arts.length;
            }
        }
        for (let i = 0; i < this.themas.length; i++) {
            if (this.themas[i].code === this.terminform.value.thema) {
                this.termindata.thema = this.themas[i];
                i = this.themas.length;
            }
        }
        this.termindata.customer = {
            salutation: this.terminform.value.salutation,
            email: this.terminform.value.email,
            partnerid: this.termindate.partnerid,
            firstname: this.terminform.value.firstname,
            lastname: this.terminform.value.lastname,
            tel: this.terminform.value.tel,
        };
        this.dialogRef.close(this.termindata);
    }
}
